export const isDevelopment = () => process.env.NODE_ENV === 'development';
export const isStaging = () => {
  if (window?.location?.host !== undefined) {
    return (
      process.env.NODE_ENV === 'test' ||
      window.location?.host.includes('revelo-bravobike.frontend.site') ||
      window.location?.host.includes('staging.jobrad-loop.com')
    );
  }
  return process.env.NODE_ENV === 'test';
};
export const isProduction = () => process.env.NODE_ENV === 'production';
